export default __webpack_public_path__ + "static/media/file.e72e0652.svg";